export default __webpack_public_path__ + "static/N0191-919525c0c80561b7c394c37b0bcf818b.png";